import { render } from "./ByFeature.vue?vue&type=template&id=f883e354&scoped=true"
import script from "./ByFeature.vue?vue&type=script&lang=js"
export * from "./ByFeature.vue?vue&type=script&lang=js"

import "./ByFeature.vue?vue&type=style&index=0&id=f883e354&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f883e354"]])

export default __exports__